"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageRange = void 0;
var pageRange = function (_a) {
    var pageIndex = _a.pageIndex, pageCount = _a.pageCount, _b = _a.rangeLength, rangeLength = _b === void 0 ? 4 : _b;
    // use 1 based index
    pageIndex++;
    // start with active page and show the next 4 pages (3 if showFirstAndLast == true)
    // use - 2 and + 2 to center active page
    var start = pageIndex;
    var end = pageIndex + rangeLength;
    if (end > pageCount) {
        start -= end - pageCount;
        end = pageCount;
    }
    if (start <= 0) {
        end += (start - 1) * -1;
        start = 1;
    }
    end = Math.min(end, pageCount);
    // set back to 0 based index
    start--;
    end--;
    var range = [];
    for (var i = start; i <= end; i++) {
        range.push(i);
    }
    return range;
};
exports.pageRange = pageRange;
